import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { CdsModalDialogComponent } from '@citi-gcg-173875/citi-common-ui-cds';
import { Subject, Subscription } from 'rxjs';

/**
   * @Component: Modal
   * @description This component generates a modal but should only be accessed through the mkt-modal.service
   */

@Component({
  selector: 'mkt-modal',
  templateUrl: './mkt-modal.component.html',
  styleUrls: ['./mkt-modal.component.scss'],
  standalone: false,
  host: { 'class': 'cbolui-cds' }
})
export class MktModalComponent implements OnDestroy, AfterViewInit {
  public previousActiveElement: HTMLElement | any;

  public onOpenStart: Subject<any>;
  public onOpenEnd: Subject<any>;
  public onCloseStart: Subject<any>;
  public onCloseEnd: Subject<any>;
  public onContinueStart: Subject<any>;
  public onContinueEnd: Subject<any>;

  private _onOpenStartSub: Subscription;
  private _onOpenEndSub: Subscription;
  private _onCloseStartSub: Subscription;
  private _onCloseEndSub: Subscription;
  private _onContinueEndSub:Subscription

  @ViewChild('cdsModalDialog') public cdsModalDialog: CdsModalDialogComponent;
  @ViewChild('cdsModalBody', { read: ElementRef }) public cdsModalBody: ElementRef;
  @ViewChild('modalHeading', { read: ElementRef }) public modalHeading: ElementRef;
  @ViewChild('intialModalFocus', { read: ElementRef }) public intialModalFocus: ElementRef;
  @ViewChild('componentPlaceholder', { read: ViewContainerRef }) public componentPlaceholder: ViewContainerRef;

  @Input('title') public title: string;
  @Input('showModal') public showModal: boolean = true;
  @Input('htmlContent') public htmlContent: string;
  // @Input('ngComponent') public ngComponent: HTMLElement | any;
  @Input('genericTemplateContent') public genericTemplateContent: any;
  @Input('isModalScrollable') public isModalScrollable:boolean = false;

  @Input('showCancelButton') public showCancelButton: boolean;
  @Input('cancelButtonText') public cancelButtonText: string;
  @Input('showPrimaryButton') public showPrimaryButton: boolean;
  @Input('primaryButtonText') public primaryButtonText: string;
  @Input('primaryButtonTarget') public primaryButtonTarget: ('_blank' | '_self' | '_parent' | '_top');
  @Input('primaryButtonUrl') public primaryButtonUrl: string;

  constructor() {
    this.onOpenStart = new Subject();
    this.onOpenEnd = new Subject();
    this.onCloseStart = new Subject();
    this.onCloseEnd = new Subject();
    this.onContinueStart = new Subject();
    this.onContinueEnd = new Subject();
  }

  ngOnDestroy() {
    this._onOpenStartSub.unsubscribe();
    this._onOpenEndSub.unsubscribe();
    this._onCloseStartSub.unsubscribe();
    this._onCloseEndSub.unsubscribe();

  }

  ngAfterViewInit() {
    this._onOpenStartSub = this.cdsModalDialog.openStart.subscribe(this.handleOpenStart.bind(this));
    this._onOpenEndSub = this.cdsModalDialog.openEnd.subscribe(this.handleOpenEnd.bind(this));
    this._onCloseStartSub = this.cdsModalDialog.closeStart.subscribe(this.handleCloseStart.bind(this));
    this._onCloseEndSub = this.cdsModalDialog.closeEnd.subscribe(this.handleCloseEnd.bind(this));

  }

  private handleOpenStart() {
    console.log("CDS MODAL initiate.");
   }

  private handleOpenEnd() {
    const si = this.title && setInterval(async () => {
      if (!this.intialModalFocus?.nativeElement) return;

      clearInterval(si);

      await this.focusElement(this.intialModalFocus?.nativeElement);

      this.onOpenEnd.next(true);
    }, 250);
  }

  private handleCloseStart() {  console.log("CDS MODAL close.") }

  private handleCloseEnd() {
    Promise.resolve().then(async () => {
      await this.focusElement(this.previousActiveElement || document.body);
      this.onCloseEnd.next(true);
    });
  }


  private focusElement(element: HTMLElement, action = "end") {
    return new Promise((resolve) => {
      setTimeout(() => {
        // Check if already active
        if (element === document?.activeElement) return resolve(true);

        // Blur HTML Element (iOS fix)
        element.blur();

        // Focus HTML Element
        (action === "continue") ? element.scrollIntoView({ block: 'center', inline: 'center' }) : element.scrollIntoView();
        element.focus();
        resolve(true);
      }, 150);
    });
  }

  close(e) {
    this.cdsModalDialog.close();
    this.onCloseStart.next(true);
  }

  continue(e) {
    this.onContinueStart.next(true);
    Promise.resolve().then(async () => {
      await this.focusElement(this.previousActiveElement || document.body, "continue");
      this.onContinueEnd.next(true);
    });

  }
}
